import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import themes from '../lib/themes';
import GettingStarted from '../components/GettingStarted/GettingStarted';

const GettingStartedContainer = (props, railsContext) => {
  // Transform props to match reducer structure
  const initialState = {
    company: { 
      host: railsContext.company_host,
      features: railsContext.features,
      file_import_disclaimer: railsContext.file_import_disclaimer,
      name: railsContext.company_name,
      branded_name: railsContext.company_branded_name,
      short_name: railsContext.company_short_name,
    },
    user: props.current_user,
    intl: {
      locale: railsContext.i18nLocale || 'en'
    }
  };

  const store = configureStore(initialState);

  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbGettingStarted',
  });

  const jss = create({
    ...jssPreset(),
  });

  const theme = themes[railsContext.theme_name];
  window.locale = railsContext.i18nLocale || 'en';

  return (
    <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbGettingStarted-">
      <MuiThemeProvider theme={createMuiTheme(theme)}>
        <CssBaseline />
        <Provider store={store}>
          <SnackbarProvider maxSnack={5}>
            <ApolloProvider client={client}>
              <GettingStarted {...props} />
            </ApolloProvider>
          </SnackbarProvider>
        </Provider>
      </MuiThemeProvider>
    </JssProvider>
  );
};

export default GettingStartedContainer;
